import { createFeatureSelector, createSelector } from '@ngrx/store';
import { NAME, selectAll, selectEntities, selectIds, State } from './toc-type.reducer';

export const selectTocTypeState = createFeatureSelector<State>(NAME);

export const getError = createSelector(selectTocTypeState, (state: State) => state.error);

export const getLoaded = createSelector(selectTocTypeState, (state: State) => state.loaded);

export const getAll = createSelector(selectTocTypeState, selectAll);

export const getIds = createSelector(selectTocTypeState, selectIds);

export const getAllEntities = createSelector(selectTocTypeState, selectEntities);
